import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';
import { Button, Chip, Typography } from '@mui/material';
import ModalStatusMachine from '../ModalStatusMachine';

function MachineProfileHeader({
  form,
  user,
  isInputsDisabled,
  setIsInputsDisabled,
  handleCancel,
  handleSubmit,
  id,
  setToastOpen,
  setForm,
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.header}>
      <div className={styles.button_group}>
        <div className={styles.title}>
          <Link to={`/machines`} style={{ textDecoration: 'none', color: 'black' }}>
            <Typography variant="h5" fontWeight="bold" sx={{ opacity: 0.5 }}>
              {t('machineList.machineList')}
            </Typography>
          </Link>

          <Typography variant="h5" fontWeight="bold">
            {form.number} {form.name}
          </Typography>
        </div>
        <Chip
          label={form.status === 'active' ? t('machineList.active') : t('machineList.inactive')}
          color={form.status === 'active' ? 'success' : 'default'}
        />
      </div>
      {user?.role === 'admin' && (
        <div className={styles.button_group}>
          {!isInputsDisabled ? (
            form.is_archived === 'non-archived' && (
              <ModalStatusMachine
                id={id}
                action={'archived'}
                size="large"
                onSuccess={() => {
                  setToastOpen(true);
                  setForm((prev) => ({ ...prev, is_archived: 'archived' }));
                }}
              />
            )
          ) : (
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCancel}
              style={{ padding: '12px 24px', textTransform: 'none' }}
            >
              {t('generic.cancel')}
            </Button>
          )}

          {!isInputsDisabled ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsInputsDisabled(true)}
              style={{ padding: '12px 24px', textTransform: 'none' }}
            >
              {t('generic.edit')}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              style={{ padding: '12px 24px', textTransform: 'none' }}
            >
              {t('generic.save')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default MachineProfileHeader;
